import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

export const image = (theme: ExactTheme) =>
  css({
    color: theme.colorsV2.grey[600],
    "@media (max-height: 400px)": {
      display: "none",
    },
  });

export const title = css({
  textAlign: "center",
});
